"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ADMIM_MENU = exports.DEFAULT_ADMIM_DEPTHS = exports.DEFAULT_MENU = exports.DEFAULT_DEPTHS = void 0;
exports.DEFAULT_DEPTHS = 'home';
exports.DEFAULT_MENU = { menu: 'home', detail: 'list' };
exports.DEFAULT_ADMIM_DEPTHS = 'classManagement';
exports.DEFAULT_ADMIM_MENU = { menu: 'classManagement', detail: 'list' };
